var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderAssets({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5046 7.41642H20.2546C20.7609 7.41642 21.1712 7.82682 21.1712 8.33309V19.3331C21.1712 19.8394 20.7609 20.2498 20.2546 20.2498H3.75456C3.2483 20.2498 2.83789 19.8394 2.83789 19.3331V4.66642C2.83789 4.16016 3.2483 3.74976 3.75456 3.74976H17.5046V7.41642ZM4.67122 9.24976V18.4164H19.3379V9.24976H4.67122ZM4.67122 5.58309V7.41642H15.6712V5.58309H4.67122ZM14.7546 12.9164H17.5046V14.7498H14.7546V12.9164Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderAssets);
export default __webpack_public_path__ + "static/media/header_assets.396cc471879cedd0561660caf0acabff.svg";
export { ForwardRef as ReactComponent };